import { render, staticRenderFns } from "./AdditionalEmail.vue?vue&type=template&id=311bb3ac&"
import script from "./AdditionalEmail.vue?vue&type=script&lang=js&"
export * from "./AdditionalEmail.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports